module.exports = __webpack_public_path__ + "img/LCRG_Swords_04.a11b0e10.png";